<div #contentWrapper class="content-wrapper" [innerHtml]="externalHtml | async | finSafe:'html'"></div>
<div #scriptWrapper class="script-wrapper is-hidden"></div>
